import {
  ManagedMessenger,
  TRUST_LEVELS,
  targetContextFromWindow,
  noopLogger,
  noopMetrics,
  array,
  object,
  record,
  string,
} from '@sail/comms';
import {SAIL_TOOLKIT_ACTIVE, SAIL_TOOLKIT_COMMUNICATION_ID} from './constants';

function createMessenger() {
  const schemasByType = {
    SAIL_UI_READY: object({}),
    SAIL_TOKEN_OVERRIDE: record(string(), string()),
    SAIL_PROBE: object({}),
    // The full set of selected theme names; an empty array clears all themes.
    SAIL_THEME_OVERRIDE: object({themeNames: array(string())}),
  };
  return new ManagedMessenger({
    self: {
      context: targetContextFromWindow(window),
      trustLevel: TRUST_LEVELS.TRUSTED,
    },
    remote: {
      context: targetContextFromWindow(window),
      origin: window.location.origin,
      trustLevel: TRUST_LEVELS.TRUSTED,
    },
    logger: noopLogger,
    metrics: noopMetrics,
    schemasByType,
    communicationId: SAIL_TOOLKIT_COMMUNICATION_ID,
    trustLocalhostOrigins: true,
  });
}

export const messenger = SAIL_TOOLKIT_ACTIVE ? createMessenger() : null;
